module.exports = __webpack_public_path__ + "img/bgc2.84f907bb.png";